export const it = {
  billing: {
    dialogTrialExpiring: {
      title: 'Prova gratuita in scadenza',
      descriptionInfo:
        'La prova gratuita scadrà in data !{BOLD}!.\nSe non inserisci un metodo di pagamento, dopo tale data, la piattaforma non potrà più essere utilizzata. Contattaci per un piano personalizzato',
      descriptionWarning:
        'La prova gratuita scadrà tra !{BOLD}!.\nSe non inserisci un metodo di pagamento, dopo tale data, la piattaforma non potrà più essere utilizzata. Contattaci per un piano personalizzato',
      descriptionInfoBold: '{{expiringDate}}',
      descriptionWarningBold: '{{deltaOfDays}} giorni, {{expiringDate}}',
      addPaymentMethod: 'Aggiungi metodo di pagamento',
      contactUs: 'Contattaci',
    },
    trialExpiringBanner: {
      messageInfo:
        'Il tuo periodo di prova gratuito scadrà il {{expiringDate}}. Aggiungi un metodo di pagamento per continuare ad utilizzare Slash dopo la scadenza',
      messageWarning:
        'La prova gratuita scadrà tra {{deltaOfDays}} giorni. Aggiungi un metodo di pagamento per continuare ad utilizzare Slash',
      cta: 'Aggiungi metodo di pagamento',
    },
    paymentFailedBanner: {
      message:
        'Il pagamento non è andato a buon fine. Aggiorna il metodo di pagamento entro 7 giorni per evitare la sospensione della piattaforma.',
      cta: 'Aggiorna metodo di pagamento',
    },
    betaExpiringBanner: {
      message:
        'Il periodo di prova della Beta scadrà il {{expiringDate}}. Attiva un piano per continuare ad utilizzare Slash dopo la scadenza',
      cta: 'Contattaci',
    },
    subscriptionMissingBanner: {
      message:
        'Non è stato possibile completare l’attivazione del tuo piano. Ci scusiamo per l’inconveniente, il nostro team è già al lavoro per risolvere il problema. Nel frattempo, puoi continuare a utilizzare Slash normalmente: l’accesso alla piattaforma è garantito. Per assistenza o informazioni, scrivici a slash@altermaind.com',
    },
    dialogPaymentFailed: {
      title: 'La piattaforma è sospesa',
      description:
        "Il pagamento non è andato a buon fine. Aggiorna il metodo di pagamento per riattivare l'accesso a Slash oppure contattaci per un piano personalizzato.",
      updatePaymentMethod: 'Aggiorna metodo di pagamento',
      logout: 'Esci',
      contactUs: 'Contattaci',
    },
    dialogSubscriptionExpiredAdmin: {
      title: 'La prova gratuita è scaduta.',
      description:
        'Per continuare ad utilizzare Slash aggiungi un metodo di pagamento o contattaci per un piano personalizzato.',
      addPaymentMethod: 'Aggiungi metodo di pagamento',
      logout: 'Esci',
      contactUs: 'Contattaci',
    },
    dialogSubscriptionExpiredLearning: {
      title: 'Licenza non più attiva',
      description:
        'Non è più possibile utilizzare la piattaforma, contatta HR per maggiori informazioni.',
      logout: 'Esci',
    },
    dialogSubscriptionBetaExpired: {
      title: 'Attiva un piano per continuare ad utilizzare Slash',
      description:
        'Il periodo di prova gratuito di 3 mesi è scaduto.\nPer continuare ad utilizzare Slash e visualizzare i dati della tua organizzazione, contattaci per attivare un piano.',
      contactUs: 'Contattaci',
      logout: 'Esci',
    },
    dialogSubscriptionMissing: {
      title: 'La piattaforma è temporaneamente sospesa',
      description:
        'Non è stato possibile completare l’attivazione del tuo piano, per cui l’accesso alla piattaforma è stato temporaneamente disabilitato.\nUn membro del nostro team ti contatterà a breve per assisterti nella risoluzione e ripristinare l’accesso nel più breve tempo possibile.\nNel frattempo, puoi scriverci direttamente a slash@altermaind.com per ricevere supporto immediato.',
      logout: 'Esci',
    },
  },
};
